/**
 * Whether the in-memory LNAT highlight/strike store should be dropped.
 * Keep across Section A timer0 → B instructions and End Exam → awaiting_p2.
 */
export function shouldClearLnatAnnotations({ event, nextPhase } = {}) {
  if (event === 'retake' || event === 'leave') return true;
  if (nextPhase === 'post_exam') return true;
  if (event === 'setIsSubmitted' && nextPhase !== 'awaiting_p2' && nextPhase !== 'awaiting_next') {
    return true;
  }
  return false;
}
